import { useCallback } from 'react';

type HapticPattern = 'light' | 'medium' | 'heavy' | 'success' | 'error';

export const useHapticFeedback = () => {
  const vibrate = useCallback((pattern: HapticPattern = 'light') => {
    // Verificar si el dispositivo soporta vibración
    if (!('vibrate' in navigator)) return;

    const patterns: Record<HapticPattern, number | number[]> = {
      light: 10,
      medium: 20,
      heavy: 30,
      success: [10, 50, 10],
      error: [20, 50, 20, 50, 20]
    };

    try {
      navigator.vibrate(patterns[pattern]);
    } catch (error) {
      console.log('Vibración no soportada');
    }
  }, []);

  return { vibrate };
};
